import { useEffect, useState } from "react";
import { IoLocationSharp } from "react-icons/io5";
import { useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../utils/components/DataTable";
import { auth } from "../../../App/routes";

const EventListTable = () => {
  const { selectedLocation, logs, translate } = useOutletContext();
  const navigate = useNavigate();

  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const columns = [
      {
        name: translate("forms.event_list.headers.event_type"),
        selector: (row) => row.eventType,
        sortable: true,
        center: true,
        cell: (row) => row.eventType,
      },
      {
        name: translate("forms.event_list.headers.event_detail"),
        selector: (row) => row.eventDetail,
        sortable: true,
        center: true,
        cell: (row) => row.eventDetail,
      },
      {
        name: translate("forms.event_list.headers.user"),
        selector: (row) => row.user,
        sortable: true,
        center: true,
        cell: (row) => row.user,
      },
      {
        name: translate("forms.event_list.headers.form_version"),
        selector: (row) => row.formVersion,
        sortable: true,
        center: true,
        cell: (row) => row.formVersion,
      },
      {
        name: translate("forms.event_list.headers.date_and_time"),
        selector: (row) => row.dateAndTime,
        sortable: true,
        center: true,
        cell: (row) => row.dateAndTime,
      },
    ];

    setColumns(columns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const conditionalRowStyles = [
    {
      when: (row) => row.eventType === "SENT",
      classNames: ["event-is-sent"],
    },
  ];

  const onRowClicked = (row) => {
    const { eventType, eventData } = row;

    if (eventType && eventType === "SENT" && eventData?.task_id) {
      const taskId = eventData?.task_id;
      navigate(auth.formBoxDetails.link.replace(":id", taskId));
    }
  };

  return (
    <div>
      <div className="row py-3 border-top border-2 ps-3">
        <div className="col-12 py-2">
          <div className="location-info-area d-flex justify-content-start align-items-start">
            <span>
              <IoLocationSharp className="fs-3 text-orange me-2" />
            </span>
            <div className="locations d-flex flex-column align-items-start">
              <div className="main-location mb-2">
                {selectedLocation ? selectedLocation?.path?.split(">")[0] : ""}
              </div>
              <div className="location-breadcrumbs text-gray">
                {selectedLocation?.path}
              </div>
            </div>
          </div>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={logs}
        pagination={true}
        conditionalRowStyles={conditionalRowStyles}
        onRowClicked={onRowClicked}
      />
    </div>
  );
};
export default EventListTable;
